"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormControl = void 0;
var react_1 = require("react");
var string_1 = require("../util/string");
function useFormControl(props) {
    var id = props.id, label = props.label, error = props.error, required = props.required, inline = props.inline;
    var labelIdRef = react_1.useRef("label-" + string_1.randomStr());
    var errorIdRef = react_1.useRef("error-" + string_1.randomStr());
    var labelId = label && !id ? labelIdRef.current : undefined;
    var errorId = error ? errorIdRef.current : undefined;
    return {
        getFormControlProps: function () { return ({
            label: label,
            error: error,
            htmlFor: id,
            labelId: labelId,
            errorId: errorId,
            required: required,
            inline: inline,
        }); },
        getInputProps: function () { return ({
            'aria-labelledby': labelId,
            'aria-invalid': !!error ? true : undefined,
            'aria-errormessage': errorId,
        }); },
    };
}
exports.useFormControl = useFormControl;
//# sourceMappingURL=useFormControl.js.map